import React from 'react';

import { DocumentLinesIcon } from '../../../svgs/DocumentLinesIcon';
import { EditPenIcon } from '../../../svgs/EditPenIcon';
import { GridSquaresIcon } from '../../../svgs/GridSquaresIcon';

import type { TabType } from './QuoteCardTabs';

export const QuoteCardTabIcons: Record<TabType, React.ReactNode> = {
  settings: <EditPenIcon size={14} />,
  transcript: <DocumentLinesIcon size={14} />,
  templates: <GridSquaresIcon size={14} />,
};
